import { Button } from '@/hen-ui/atomics/Button';
import { Text } from '@/hen-ui/atomics/Text';

import { CareerExplorerRecommendationList } from './CareerExplorerRecommendationList';
import type { CareerExplorerRecommendation } from './types';

interface CareerExplorerRecommendationsBodyProps {
  programs: CareerExplorerRecommendation[];
  recommendationReason: string;
  emptyMessage: string;
  viewAllLabel: string;
  viewAllHref: string;
}

export const CareerExplorerRecommendationsBody = ({
  emptyMessage,
  programs,
  recommendationReason,
  viewAllHref,
  viewAllLabel,
}: CareerExplorerRecommendationsBodyProps) => {
  if (programs.length === 0) {
    return (
      <Text variant='b3' className='text-neutral-500'>
        {emptyMessage}
      </Text>
    );
  }

  return (
    <>
      <Text variant='b3' className='text-neutral-500'>
        {recommendationReason}
      </Text>

      <CareerExplorerRecommendationList programs={programs} />

      <Button
        href={viewAllHref}
        variant='textOnlyNeutral'
        size='flush'
        className='self-center text-b3 leading-b3 text-neutral-900 hover:text-neutral-900 hover:no-underline active:text-neutral-900'
      >
        {viewAllLabel}
      </Button>
    </>
  );
};
